import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
  margin: 21px 0 34px 0;
  background: ${({ theme }) => theme.backgrounds.workspaceStats};
  & > *:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.borders.workspaceStats};
  }
`;
Wrapper.displayName = 'Wrapper';

export const WrapperItem = styled.div`
  flex-direction: row;
  width: 100%;
  display: flex;
`;
WrapperItem.displayName = 'WrapperItem';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 21%;
  margin: 13px;
  text-align: center;
`;
Item.displayName = 'Item';

export const TotalBlack = styled.div`
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.text.workspaceHighlightStat};
`;
TotalBlack.displayName = 'TotalBlack';

export const TotalGrey = styled(TotalBlack)`
  color: ${({ theme }) => theme.text.workspaceStat};
`;
TotalGrey.displayName = 'TotalGrey';

export const TotalPurple = styled(TotalBlack)`
  color: ${({ theme }) => theme.text.workspaceCriticalStat};
`;
TotalPurple.displayName = 'TotalPurple';

export const Label = styled.div`
  font-size: 10px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.grey5};
  font-family: 'CentraNo2';
  margin-top: 2px;
`;
Label.displayName = 'Label';
